import { Injectable } from '@angular/core';
import { PSTelemetryAlertProfile, DefaultService } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PsAlertProfilesService {

  constructor(private powerSupplyService: DefaultService) {
    this.getAllAlertsProfile();
  }
  getAllAlertsProfile() {
    return this.powerSupplyService.getAllPsAlertsProfile().pipe(map(result => result));
  }

  createPsAlertProfiles(model: PSTelemetryAlertProfile[]) {
    return this.powerSupplyService.createPsAlertProfiles(model).pipe(map(result => result));
  }

  updatePsAlertsProfile(model: PSTelemetryAlertProfile) {
    return this.powerSupplyService.updatePsAlertsProfile(model).pipe(map(result => result));
  }

  deletePsAlertsProfile(id: number) {
    return this.powerSupplyService.deletePsAlertsProfile(id).pipe(map(result => result));
  }
}
